import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';

import PromoInfoCard from '~/src/features/bundles/components/PromoInfoCard';
import { PromoInfoData } from '~/src/features/bundles/data/contents';

import { SectionWrapper } from './styled';

interface IProps {
    companyName: string,
}

const PromoInfo = ({ companyName }: IProps): JSX.Element => {
    return (
        <SectionWrapper>
            <H3 as='h2'>Что получает каждый клиент {companyName}</H3>
            <NukaCarousel
                scrollMode={'remainder'}
                withoutArrows
                withoutDots
                cellSpacing={24}
                framePadding='0'
                slideWidth={'230px'}
                data-test='tariff-offer-card-offer-contents-carousel'
            >
                {PromoInfoData.map((item, key) =>
                    <PromoInfoCard
                        key={key}
                        {...item}
                    />)}
            </NukaCarousel>
        </SectionWrapper>
    );
};

export default PromoInfo;
